module.exports = __webpack_public_path__ + "img/dlqh-on.8e73d53c.svg";